import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "SecondsToMinutesPipe",
})
export class SecondsToMinutesPipe implements PipeTransform {
  transform(seconds: number): string {
    const minutes: number = Math.floor(seconds / 60);
    return (
      minutes.toString().padStart(2, "0") +
      ":" +
      (seconds - minutes * 60).toString().padStart(2, "0")
    );
  }
}
